
<template>
  <div class="addEditCommodity">
    <div class="dialogContainer">
      <el-form
        ref="addCommodityForm"
        :model="addCommodityForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <!-- <span style="margin-left: 140px;color: #c51414;" v-show="specNoTips">该编号库存有一个以上商品，请联系仓管</span> -->
        <el-form-item label="商品编码：" prop="specNo">
          <span v-if="showview">{{ addCommodityForm.specNo }}</span>
          <span v-else>

            <el-input
              v-model="addCommodityForm.specNo"
              name="specNo"
              maxlength="200"
              class="handle-form-inputT"
              :disabled="propsCommodity.type === 'edit'"
              clearable
            />
            <el-button
              size="small"
              type="primary"
              @click="spuHandleSearchFilter"
            >货品查询</el-button>
            <!-- <el-button
              size="mini"
              type="primary"
              @click="skuHandleSearchFilter"
              >单品查询</el-button
            >-->
          </span>
        </el-form-item>
        <el-form-item label="商品名称：" prop="name">
          <span v-if="showview">{{ addCommodityForm.name }}</span>
          <span v-else>
            <el-input
              v-model="addCommodityForm.name"
              name="name"
              maxlength="32"
              class="handle-form-input"
            />
          </span>
        </el-form-item>
        <div class="flexleft">
          <!-- <el-form-item label="商品规格：" prop="spec">
            <span v-if="showview">{{ addCommodityForm.spec }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.spec"
                name="spec"
                maxlength="200"
                class="handle-form-input"
              ></el-input>
            </span>
          </el-form-item> -->
          <el-form-item label="规格属性：" prop="specUnitType">
            <span v-if="showview">{{ addCommodityForm.specUnitType==='Y'?'年':addCommodityForm.specUnitType==='Q'?'季':'月' }}</span>
            <span v-else>
              <el-select
                v-model="addCommodityForm.specUnitType"
                name="type"
                size="medium"
                class="handle-form-input"
              >
                <el-option label="年" value="Y" />
                <el-option label="季" value="Q" />
                <el-option label="月" value="M" />
              </el-select>
              <!-- <el-input
                v-model="addCommodityForm.specUnitType"
                name="specUnitType"
                maxlength="200"
                class="handle-form-input"
              ></el-input> -->
            </span>
          </el-form-item>
          <el-form-item label="规格单位：" prop="specUnit">
            <span v-if="showview">{{ addCommodityForm.specUnit }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.specUnit"
                name="specUnit"
                maxlength="2"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </span>
          </el-form-item>
          <el-form-item label="有效天数：" prop="auxUnit">
            <span v-if="showview">{{ addCommodityForm.auxUnit }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.auxUnit"
                name="auxUnit"
                maxlength="3"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d]/g,'')"
              />
            </span>
          </el-form-item>
        </div>
        <div class="flexleft">
          <el-form-item label="商品售价（元）：" prop="price">
            <span v-if="showview">{{ addCommodityForm.price }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.price"
                name="price"
                maxlength="10"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d\.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
              />
            </span>
          </el-form-item>
          <el-form-item label="商品原价（元）：" prop="originalPrice">
            <span v-if="showview">{{ addCommodityForm.originalPrice }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.originalPrice"
                name="originalPrice"
                maxlength="10"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d\.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
              />
            </span>
          </el-form-item>
          <!-- V17.1 -->
          <el-form-item label="商品会员价（元）：" prop="vipPrice">
            <span v-if="showview">{{ addCommodityForm.vipPrice }}</span>
            <span v-else>
              <el-input
                v-model="addCommodityForm.vipPrice"
                name="vipPrice"
                maxlength="10"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d\.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
              />
            </span>
          </el-form-item>
        </div>

        <el-form-item label="业务编码：" prop="code">
          <span v-if="showview">{{ addCommodityForm.code }}</span>
          <span v-else>
            <el-input
              v-model="addCommodityForm.code"
              name="code"
              maxlength="10"
              class="handle-form-input"
            />
          </span>
        </el-form-item>
        <!-- v17.1 -->
        <el-form-item label="商品图片：" prop="imgUrl" class="uploadImg">
          <span v-if="showview" style="width:300px;display: inline-block;">
            <img
              :src="addCommodityForm.imgUrl"
              class="avatarImg"
            ></span>
          <span v-else>
            <upload-file
              :props="{
                serveCode: 'product_manage',
                accept: '.png, .jpg, .jepg',
                type: ['image/jpeg', 'image/gif', 'image/png'],
              }"
              @uploadSucess="uploadSucessFnImg"
            >
              <div v-if="!addCommodityForm.imgUrl">
                <el-button type="primary" size="medium">添加</el-button><span style="margin-left: 10px">推荐尺寸230x140,JPG/PNG</span>
              </div>
              <div v-else class="el-upload-box">
                <div>
                  <img :src="addCommodityForm.imgUrl" class="avatarImg">
                </div>
                <i class="el-icon-refresh" /> <span>重新上传</span>
              </div>
            </upload-file>
          </span>
        </el-form-item>
        <el-form-item label="商品备注：" prop="remark">
          <span v-if="showview">{{ addCommodityForm.remark }}</span>
          <span v-else>
            <el-input
              v-model="addCommodityForm.remark"
              type="textarea"
              name="remark"
              maxlength="1024"
              class="handle-form-input"
            />
          </span>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <span v-if="showview">
        <el-button
          size="medium"
          @click="$emit('closeCommodity')"
        >取消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="$emit('closeCommodity')"
        >确定</el-button></span>
      <span v-else>
        <el-button
          size="medium"
          @click="$emit('closeCommodity')"
        >取消</el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleaddCommodity"
        >{{ ajaxLoading ? "Loading" : "保存" }}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import {
  getGoodsSkuList,
  getGoodsQuerySku,
  getGoodsAdd,
  getGoodsEdit,
  getGoodsDetails
} from '@/api/userManagement/index/';
import { validateVipPrice, validatePrice, validateOriginalPrice } from '@/utils/validate';
export default {
  name: 'AddEditCommodity',
  props: {
    propsCommodity: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      addCommodityForm: {
        code: '',
        name: '',
        specNo: '',
        specUnit: '',
        price: '',
        originalPrice: '',
        goodsNo: '',
        imgUrl: ''
      },
      ajaxLoading: false,
      showview: false,
      specNoTips: false,
      handleRules: {
        specNo: [
          { required: true, message: '商品编码不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' }
        ],
        specUnitType: [
          { required: true, message: '规格属性不能为空', trigger: 'change' }
        ],
        specUnit: [
          { required: true, message: '规格单位不能为空', trigger: 'blur' }
        ],
        auxUnit: [
          { required: true, message: '有效天数不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, trigger: 'blur', validator: validatePrice }
        ],
        originalPrice: [
          { required: true, trigger: 'blur', validator: validateOriginalPrice }
        ],
        vipPrice: [
          { required: true, trigger: 'blur', validator: validateVipPrice }
        ],
        code: [
          { required: true, message: '业务编码不能为空', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '商品图片不能为空', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    propsCommodity: {
      handler(val) {
        if (val) {
          this.init();
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.specNoTips = false;
      if (this.propsCommodity.type === 'add') {
        this.addCommodityForm = {};
      } else {
        this.goodsDetailsFn();
      }
      if (this.propsCommodity.type === 'view') {
        this.showview = true;
      } else {
        this.showview = false;
      }
    },
    // 文件上传成功回调
    uploadSucessFnImg(val) {
      this.$set(this.addCommodityForm, 'imgUrl', val.absolutePath);
      this.$refs.addCommodityForm.validateField('imgUrl');
    },

    goodsDetailsFn() {
      getGoodsDetails(this.propsCommodity.id)
        .then((res) => {
          if (res.data) {
            this.addCommodityForm = res.data;
          } else {
            this.addCommodityForm = {};
          }
        })
        .catch((err) => {
          console.log(err);
          this.addCommodityForm = {};
        });
    },
    skuHandleSearchFilter() {
      var option = {
        sku: this.addCommodityForm.specNo
      };
      getGoodsSkuList(option)
        .then((res) => {
          if (res.data) {
            this.addCommodityForm = res.data;
          } else {
            this.addCommodityForm = {};
          }
        })
        .catch((err) => {
          console.log(err);
          this.addCommodityForm = {};
        });
    },
    spuHandleSearchFilter() {
      var option = {
        sku: this.addCommodityForm.specNo
      };
      getGoodsQuerySku(option)
        .then((res) => {
          if (res.data) {
            this.addCommodityForm = res.data;
            // if (res.data) {
            //   this.specNoTips = true;
            // }
          } else {
            this.$message.error('查询无结果');
            const specNo = {
              specNo: this.addCommodityForm.specNo
            };
            this.addCommodityForm = { ...specNo
            };
          }
        })
        .catch((err) => {
          console.log(err);
          const specNo = {
            specNo: this.addCommodityForm.specNo
          };
          this.addCommodityForm = { ...specNo
          };
        });
    },
    handleaddCommodity() {
      var self = this;
      this.$refs['addCommodityForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.propsCommodity.type === 'add') {
            var option = {
              code: this.addCommodityForm.code,
              name: this.addCommodityForm.name,
              spec: this.addCommodityForm.spec,
              specUnit: this.addCommodityForm.specUnit,
              auxUnit: this.addCommodityForm.auxUnit,
              price: this.addCommodityForm.price,
              originalPrice: this.addCommodityForm.originalPrice,
              vipPrice: this.addCommodityForm.vipPrice,
              specNo: this.addCommodityForm.specNo,
              specUnitType: this.addCommodityForm.specUnitType,
              type: this.addCommodityForm.type,
              imgUrl: this.addCommodityForm.imgUrl,
              remark: this.addCommodityForm.remark
            };
            getGoodsAdd(option)
              .then((res) => {
                self.$emit('fetchCommodityFn');
                self.$emit('closeCommodity');
                self.ajaxLoading = false;
                self.$notify.success({
                  title: 'Success',
                  message: '新增成功',
                  showClose: false,
                  duration: 2000
                });
              })
              .catch(() => {
                self.ajaxLoading = false;
              });
          } else {
            var option1 = {
              id: this.propsCommodity.id,
              code: this.addCommodityForm.code,
              name: this.addCommodityForm.name,
              spec: this.addCommodityForm.spec,
              auxUnit: this.addCommodityForm.auxUnit,
              specUnit: this.addCommodityForm.specUnit,
              price: this.addCommodityForm.price,
              originalPrice: this.addCommodityForm.originalPrice,
              vipPrice: this.addCommodityForm.vipPrice,
              specNo: this.addCommodityForm.specNo,
              specUnitType: this.addCommodityForm.specUnitType,
              type: this.addCommodityForm.type,
              imgUrl: this.addCommodityForm.imgUrl,
              remark: this.addCommodityForm.remark
            };
            getGoodsEdit(option1)
              .then((res) => {
                self.$emit('fetchCommodityFn');
                self.$emit('closeCommodity');
                self.ajaxLoading = false;
                self.$notify.success({
                  title: 'Success',
                  message: '修改成功',
                  showClose: false,
                  duration: 2000
                });
              })
              .catch(() => {
                self.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" >
.addEditCommodity {
  .avatar-uploader .el-upload-box {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-size: 12px;
    line-height: 22px;
    width: 300px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.addEditCommodity {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 90%;
  margin-right: 10px;
}
.handle-form-inputT {
  width: 78%;
  margin-right: 10px;
}
.dialog-footer {
  padding: 20px;
  margin-left: 300px;
  text-align: right;
}
.flexleft {
  width: 45%;
  display: inline-block;
  vertical-align: top;
}
.avatarImg {
  width: 100%;
}
</style>
